<template>
<td>
     <div class="km-widget km-buttongroup k-widget k-button-group k-button-narrow">

                    <button v-if="pravice"
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediKmg" title="KMG">
                         <font-awesome-icon icon="edit"/>
                    </button>

                    <button v-if="pravice"
                        class="k-primary k-button k-grid-edit-command"
                        @click="prikaziGerke"  title="Gerki">
                         <font-awesome-icon icon="layer-group"/>
                    </button>
                    <button v-if="pravice"
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediKulture" title="Kulture">
                         <font-awesome-icon icon="seedling"/>
                    </button>
                    <button v-if="pravice"
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediZivali" title="Živali">
                         <font-awesome-icon icon="horse-head"/>
                    </button>
                     <button v-if="pravice"
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediProizvode" title="Proizvodi">
                         <font-awesome-icon icon="cheese"/>
                    </button>
                    <button v-if="pravice"
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediKontrole" title="Kontrole">
                         <font-awesome-icon icon="search-location"/>
                    </button>
                    <button v-if="pravice"
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediOdlocbe" title="Odločbe">
                         <font-awesome-icon icon="file-contract"/>
                    </button>
                     <button v-if="pravice"
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediCertifikat" title="Certifikat">
                         <font-awesome-icon icon="certificate"/>
                    </button>
                    <button :class="klicajClass"  class="k-button k-grid-edit-command"
                        
                        @click="klicajInfo" title="Preverjanje">
                         <font-awesome-icon :icon="klicajIkona"/>
                    </button>
                    </div>
                </td>
</template>
<script>

import { pridelavaService } from '../../services/pridelava.service';
import { Button } from '@progress/kendo-vue-buttons';
export default {

    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        sezona: Number,
        pravice:Boolean,
    },
    components: {
    kbutton: Button,
    },
    computed: {

        //poglej če je group header
        //poglej če obstaja this.dataItem.field in potem this.data.items[0][field]
    
     
    },
    data() {
        return {
            klicajClass:"k-primary",
            klicajIkona:"info",
            sporocila:[],

        }
    },
    mounted () {

        pridelavaService.loadOneKlicaj(this.dataItem.sezona,this.dataItem.id).then(seznam=>{
            this.sporocila=seznam;
            if(seznam.find(i=>i.vrstasporocila==0)){
                this.klicajIkona="info";
                this.klicajClass="k-primary";
            }

            if(seznam.find(i=>i.vrstasporocila==1)){
                this.klicajIkona="exclamation";
                this.klicajClass="k-warning";
            }

            if(seznam.find(i=>i.vrstasporocila==2)){
                this.klicajIkona="times";
                this.klicajClass="k-error";
            }

        })

    },
    template: ` 
                `,
    methods: {
        //...mapActions('pridelava', ['select']),
        klicajInfo: function() {
            //alert("Opozorilo!!!");
            if(this.sporocila.length>0)
                this.$emit('prikaziSporocila',this.sporocila);
            /*

            */
        },
        prikaziGerke: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'gerk', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
        urediKmg: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'pridelovalec', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
        urediKulture: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'kultura', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
          urediZivali: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'zival', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
          urediProizvode: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'proizvod', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
           urediKontrole: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'kontrola', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
           urediOdlocbe: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'odlocba', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
         urediCertifikat: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'certifikat', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        }
    }
}
</script>
